export default {
  SET_LOCK_VIEW_TO_CENTER (state, bool) {
    state.lockViewToCenter = bool
  },
  SET_TEMPORARY_CENTER_OF_MANUALLY_MOVED_MAP (state, payload) {
    state.temporaryCenterOfManuallyMovedMap = payload
  },
  SET_GEO_POSITION_CENTER (state, payload) {
    state.geoPositionCenter = payload
  },
  SET_CURRENT_GEO_POSITION (state, payload) {
    state.currentGeolocation.lon = payload[0]
    state.currentGeolocation.lat = payload[1]
    state.currentGeolocation.altitude = payload[2]
    // state.currentGeolocation.timestamp = payload[3]
    state.currentGeolocation.heading = payload[4]
    state.currentGeolocation.speed = payload[5]
    state.currentGeolocation.accuracy = payload[6]
    // state.currentGeolocation.altitudeAccuracy = payload[7]
    // state.currentGeolocation.recording = payload[8]
    state.currentGeolocation.distanceM = payload[9].m
    state.currentGeolocation.distanceKM = payload[9].km
    // state.currentGeolocation.distanceMiles = payload[9].miles
    // state.currentGeolocation.distanceSeaMiles = payload[9].seaMiles
    // state.currentGeolocation.distanceInches = payload[9].inches
    // state.currentGeolocation.distanceFeet = payload[9].feet
    // state.currentGeolocation.steps = payload[10]
  }
  // This is with reverse GeoCoding, meaning: address data
  // @TODO: not implemented yet, but keep it
  // START_GEOLOCATION_DATA (state, payload) {
  //   state.startGeoLocData.lat = payload.lat
  //   state.startGeoLocData.lon = payload.lon
  //   state.startGeoLocData.accuracy = payload.accuracy
  //   state.startGeoLocData.altitude = payload.altitude
  //   state.startGeoLocData.altitudeAccuracy = payload.altitudeAccuracy
  //   state.startGeoLocData.heading = payload.heading
  //   state.startGeoLocData.speed = payload.speed
  //   state.startGeoLocData.latFixedFloat = payload.latFixedFloat
  //   state.startGeoLocData.lonFixedFloat = payload.lonFixedFloat
  //   state.startGeoLocData.plz = payload.plz
  //   state.startGeoLocData.city = payload.city
  //   state.startGeoLocData.district = payload.district
  //   state.startGeoLocData.houseNumber = payload.houseNumber
  //   state.startGeoLocData.label = payload.label
  //   state.startGeoLocData.neighbourhood = payload.neighbourhood
  //   state.startGeoLocData.county = payload.county
  //   state.startGeoLocData.country = payload.country
  //   state.startGeoLocData.state = payload.state
  //   state.startGeoLocData.additionalData = payload.additionalData
  // },
}
